const apiBase = (import.meta.env.VITE_API_URL ?? "http://localhost:8787").replace(
  /\/$/,
  "",
);

/** Feeds are served from the API worker at /ritual/feed.{xml,json}. */
const RSS_URL = `${apiBase}/ritual/feed.xml`;
const JSON_URL = `${apiBase}/ritual/feed.json`;

/** Paper-desk "Subscribe" affordance linking the RSS + JSON feeds. */
export function SubscribeRitual() {
  return (
    <div className="subscribe" aria-label="Subscribe to the Ritual feed">
      <span className="subscribe-note">pin it to your reader —</span>
      <a
        className="subscribe-link"
        href={RSS_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        RSS / Atom
      </a>
      <a
        className="subscribe-link"
        href={JSON_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        JSON Feed
      </a>
    </div>
  );
}
